<template>
  <div class="d-flex flex-wrap" style="padding: 5px">
    <v-btn
      small
      tile
      style="border: 1px solid #c4c4c4"
      :disabled="editingItemIndex != null"
      @click="copyItem"
    >
      <v-icon left small> mdi-content-copy </v-icon>
      アイテムをコピーする
    </v-btn>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'CopyItemBtn',
  props: {
    item: {
      type: Object,
      required: true
    },
    index: {
      type: Number,
      default: null,
      required: false
    }
  },
  computed: {
    ...mapState({
      editingItemIndex: (state) => state.PostEditor.editingItemIndex
    })
  },
  data () {
    return {
      showButton: false
    }
  },
  methods: {
    copyItem () {
      this.showButton = true
      const payload = {
        index: this.index + 1,
        item: {
          id: null,
          variety: this.item.variety,
          order: null,
          _destroy: false,
          newItem: true,
          itemableAttributes: this.item.itemableAttributes
        }
      }
      this.$store.commit('PostEditor/ADD_NEW_ITEM', payload)
    }
  }
}
</script>
